export const notUndefined = (val) => val !== void 0;
export const isDefined = (val) => val !== void 0 && val !== null;
export const isUndefined = (val) => !isDefined(val);
